import React from 'react'
import undefsafe from 'undefsafe'

import VideoLoader from '../videoLoader'
import Magnifier from './magnifier'

const MagnifierConfigurator = ({item, preferences}) => {
  const previews = item.previews
  const videoMuted = undefsafe(preferences, 'searchVideoMuted')

  const getMagnifier = () => {
    if (undefsafe(previews, 'icon_with_square_preview.square_url')) {
      return (
        <Magnifier item={item} width={300} height={300}>
          <img src={previews.icon_with_square_preview.square_url} />
        </Magnifier>
      )
    }

    if (undefsafe(previews, 'icon_with_thumbnail_preview.thumbnail_url')) {
      const width = previews.icon_with_thumbnail_preview.thumbnail_width || 300
      const height = previews.icon_with_thumbnail_preview.thumbnail_height || 300
      return (
        <Magnifier item={item} width={width} height={height}>
          <img src={previews.icon_with_thumbnail_preview.thumbnail_url} />
        </Magnifier>
      )
    }

    if (undefsafe(previews, 'icon_with_video_preview.video_url')) {
      return (
        <Magnifier item={item} width={477} height={264}>
          <VideoLoader
            autoPlay
            loop
            muted={videoMuted}
            src={previews.icon_with_video_preview.video_url}
            poster={previews.icon_with_video_preview.landscape_url} />
        </Magnifier>
      )
    }

    if (undefsafe(previews, 'icon_with_landscape_preview.landscape_url')) {
      return (
        <Magnifier item={item} width={477} height={240}>
          <img src={previews.icon_with_landscape_preview.landscape_url} />
        </Magnifier>
      )
    }

    return null
  }

  return (
    <div className='fds-u-hide-small-and-below'>
      {getMagnifier()}
    </div>
  )
}

export default MagnifierConfigurator



// WEBPACK FOOTER //
// ./client/components/magnifier/configurator.js